import { useEffect, useState } from "react";
import { GetInvoices } from "../../../_api/Admin";
import { useOutletContext } from "react-router-dom";
import { round } from "../../../_helpers/functions";
import { PaymentMethod } from "../../../_helpers/PaymentMethod";
import { useScript } from "../../../_helpers/useScript";

export const Subscription = (props) => {
    useScript("https://js.stripe.com/v3/");

    let { isInContext, currentApp, currentMenu, currentTab, user, setUser } = props;

    if (isInContext) {
        [user, setUser, currentApp, currentMenu, currentTab] = useOutletContext();
    }

    const features_right = user.policy.rights[currentApp][currentMenu.id]["sub_menu"]["INFO_SUBSCRIPTION"]["features"];

    const [invoices, setInvoices] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    const getInvoices = () => {
        setIsLoading(true);
        GetInvoices()
            .then((resp) => {
                setInvoices(resp.data);
                setIsLoading(false);
            })
            .then((resp) => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        getInvoices();
    }, []);

    return (
        <div className="p-4">
            <PaymentMethod user={user} setUser={setUser} features_right={features_right} />

            {isLoading && <p className=" mt-4">En chargement</p>}
            {!isLoading && (
                <table className="w-full mt-6 border-collapse shadow-md rounded-lg overflow-hidden">
                    <thead className="bg-app-primary text-white">
                        <tr>
                            <th colSpan={3} className="text-xl font-semibold py-3">
                                Factures
                            </th>
                        </tr>
                        <tr className="bg-app-primary/80">
                            <th className="text-left py-2 px-4">Date</th>
                            <th className="text-left py-2 px-4">Montant</th>
                            <th className="text-left py-2 px-4">Statut</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white">
                        {invoices.map((invoice) => {
                            let currency = invoice.currency === "eur" ? "€" : "$";
                            let date = new Date(invoice.period_end * 1000)
                                .toDateString()
                                .split(" ");
                            return (
                                <tr
                                    key={invoice.id}
                                    className="border-b hover:bg-app-primary/10 transition-colors cursor-pointer"
                                    onClick={() =>
                                        window.open(invoice?.hosted_invoice_url, "_blank")
                                    }
                                >
                                    <td className="py-2 px-4 text-app-primary font-medium">
                                        {date[1]} {date[3]}
                                    </td>
                                    <td className="py-2 px-4">
                                        {currency}
                                        {round(invoice.amount_paid / 100, 2)}
                                    </td>
                                    <td className={`py-2 px-4 font-semibold ${invoice.amount_paid === 0 ? "text-yellow-500" : "text-green-500"}`}>
                                        {invoice.amount_paid === 0 ? "Période d'essai" : "Payé"}
                                    </td>
                                </tr>
                            );
                        })}
                        {invoices.length === 0 && (
                            <tr className="border-b">
                                <td colSpan={3} className="py-4 text-center text-gray-500">
                                    Il n'y a pas de factures
                                </td>
                            </tr>
                        )}
                    </tbody>
                </table>

            )}
        </div>
    );
};

export default Subscription;
